var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('widget-mask',[_c('div',{staticClass:"widget-loading"},[_c('div',{staticClass:"widget-loading-title"},[_vm._v("Loading")]),_c('div',{staticClass:"widget-loading-wrapper"},_vm._l((3),function(i){return _c('span',{key:i})}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }